import { colorsSets } from "@similarweb/styles";

export enum DifficultyLevel {
    Difficult = "Difficult",
    Moderate = "Moderate",
    Easy = "Easy",
}

export type DifficultyLevelLimits = {
    LOWEST: number;
    HIGHEST: number;
};
export const getDifficultyLevel = (
    difficultyGrade: number,
    difficultyLevelsWithLimits: Record<DifficultyLevel, DifficultyLevelLimits>,
) => {
    if (
        difficultyGrade >= difficultyLevelsWithLimits[DifficultyLevel.Easy].LOWEST &&
        difficultyGrade <= difficultyLevelsWithLimits[DifficultyLevel.Easy].HIGHEST
    ) {
        return DifficultyLevel.Easy;
    }
    if (
        difficultyGrade >= difficultyLevelsWithLimits[DifficultyLevel.Moderate].LOWEST &&
        difficultyGrade <= difficultyLevelsWithLimits[DifficultyLevel.Moderate].HIGHEST
    ) {
        return DifficultyLevel.Moderate;
    }
    if (
        difficultyGrade >= difficultyLevelsWithLimits[DifficultyLevel.Difficult].LOWEST &&
        difficultyGrade <= difficultyLevelsWithLimits[DifficultyLevel.Difficult].HIGHEST
    ) {
        return DifficultyLevel.Difficult;
    }
};
export const DIFFICULTY_LEVEL_WITH_LIMITS = {
    [DifficultyLevel.Easy]: {
        LOWEST: 1,
        HIGHEST: 20,
    },
    [DifficultyLevel.Moderate]: {
        LOWEST: 21,
        HIGHEST: 80,
    },
    [DifficultyLevel.Difficult]: {
        LOWEST: 81,
        HIGHEST: 100,
    },
};
export const MAP_DIFFICULTY_LEVEL_TO_BACKGROUND_COLOR = {
    [DifficultyLevel.Difficult]: colorsSets.diverging["red 400"] as string,
    [DifficultyLevel.Moderate]: colorsSets.diverging["sky 200"] as string,
    [DifficultyLevel.Easy]: colorsSets.diverging["blue 400"] as string,
} as const;
